<template>
    <div>
      <modal-add-user-note ref="addUserNoteDialog"></modal-add-user-note>
      <modal-add-company-user ref="addCompanyUserDialog" :item="this.id" />
        <data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="total"
            :loading="loading"
            class="row-pointer"
            @click:row="onRowClicked"
        >
            <template v-slot:item.actions="{ item }">
              <v-btn primary @click.stop="$refs.addUserNoteDialog.open(item.id)">Notatki</v-btn>
            </template>
            <template v-slot:item.email="{ item }">
      <span
          v-html="emailLink(item.email)"
          @click="onEmailClicked"
      ></span>
              <v-tooltip top color="primary" v-if="item.notes.length">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                      v-bind="attrs"
                      v-on="on"
                      label
                      small
                      color="primary"
                  >
                    ?
                  </v-chip>
                </template>
                <div>
                  <p v-for="note in item.notes" :key="note">{{ note.note }}</p>
                </div>
              </v-tooltip>
            </template>
        </data-table>
        <v-btn
            class="mx-2"
            @click="showAddCompanyUserModal()"
        >
            Dodaj nowego użytkownika
        </v-btn>
    </div>
</template>

<script>
import api from "@/services/api";
import formatters from '../mixins/formatters';
import DataTable from "@/components/data-table/DataTable";
import ModalAddCompanyUser from "./ModalAddCompanyUser";
import ModalAddUserNote from "@/components/ModalAddUserNote.vue";

export default {
    mixins: [formatters],
    props: {
        id: {
            type: [Number, String],
            required: true,
        }
    },
    components: {
      ModalAddUserNote,
        DataTable,
        ModalAddCompanyUser,
    },
    data() {
        return {
            loading: true,
            items: [],
            total: 0,
            options: {},
            headers: [
                {text: 'Imię', value: 'name', sortable: false},
                {text: 'Nazwisko', value: 'surname', sortable: false},
                {text: 'Email', value: 'email', sortable: false},
                {text: 'Info', value: 'info', sortable: false},
                {text: 'Telefon', value: 'phone', sortable: false},
                {text: 'Akcje', value: 'actions', sortable: false},
            ],
        };
    },
    created() {
        this.getUsers();
    },
    methods: {
        async showAddCompanyUserModal() {
            this.$refs.addCompanyUserDialog
                .open()
        },
        getUsers() {
            this.loading = true;

            const {page, itemsPerPage} = this.options;
            const params = {
                offset: page > 1 ? itemsPerPage * (page - 1) : 0,
            };

            if (-1 !== itemsPerPage) {
                params.limit = itemsPerPage;
            }

            api.get(`/api/companies/${this.id}/users`, {params})
                .then((response) => {
                    this.items = response.data.items;
                    this.total = response.data.total;
                })
                .catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się wczytać danych użytkowników.',
                        error,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onEmailClicked(event) {
            // The following line is required to avoid triggering onRowClicked() method.
            event.cancelBubble = true;
            event.stopPropagation();
        },
        onRowClicked(user) {
            this.$router
                .push({name: 'user-details', params: {id: user.id}})
                .catch((error) => {
                    if (String(error).includes('Avoided redundant navigation to current location')) {
                        return;
                    }

                    throw error;
                });
        },
    },
}
</script>